<div class="loader">
  <div *ngIf="isLoading | async" class="loading-spinner"></div>
  <img  *ngIf="isLoading | async" class="loading-img" alt="" src="../../../../assets/images/loader.gif" />
</div>

